






























import { Component, Vue } from 'vue-property-decorator';
import PdawToolbar from './components/pdaw-toolbar/pdaw-toolbar';
import PdawSelectGav from './components/pdaw-select-gav/pdaw-select-gav';
import PdawGav from './components/pdaw-gav/pdaw-gav';
@Component({
  components: {
    PdawToolbar,
    PdawSelectGav,
    PdawGav,
  },
})
export default class App extends Vue {}
